export const cilMoney = ["24 24","<path d='M20.25 3h-19.5v15h19.5zM18.75 16.5h-16.5v-12h16.5z'></path><path d='M21.75 6.75v12.75h-17.25v1.5h18.75v-14.25h-1.5z'></path><path d='M10.5 14.178c1.861 0 3.375-1.647 3.375-3.672s-1.514-3.672-3.375-3.672-3.375 1.647-3.375 3.672 1.514 3.672 3.375 3.672zM10.5 8.335c1.034 0 1.875 0.974 1.875 2.172s-0.841 2.172-1.875 2.172-1.875-0.974-1.875-2.172 0.841-2.172 1.875-2.172z'></path><path d='M3.75 6.375h1.5v8.25h-1.5v-8.25z'></path><path d='M15.75 6.375h1.5v8.25h-1.5v-8.25z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-money.js
// module id = null
// module chunks = 